import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative h-56 overflow-hidden rounded-lg md:h-[70vh]" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-6 h-6 text-white dark:text-gray-800",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 19l-7-7 7-7",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Previous", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-6 h-6 text-white dark:text-gray-800",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9 5l7 7-7 7",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

import { onMounted } from 'vue'
import { initCarousels } from 'flowbite'
import { isEmpty } from 'radash'
const carouselArrowStyles = 'inline-flex items-center justify-center w-10 h-10 rounded-full bg-black/40 dark:bg-gray-800/30 group-hover:bg-black/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-gray-300 dark:group-focus:ring-gray-800/70 group-focus:outline-none'


export default /*#__PURE__*/_defineComponent({
  __name: 'image',
  props: {
    images: {},
    imagePrefixURL: {}
  },
  setup(__props: any) {

const props = __props

const id = 'carousel-image-' + new Date().getTime()

onMounted(() => {
    initCarousels()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: id,
    class: "relative w-full",
    "data-carousel": "slide"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.images, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "hidden duration-700 ease-in-out",
          "data-carousel-item": ""
        }, [
          _createElementVNode("img", {
            src: `${!_unref(isEmpty)(_ctx.imagePrefixURL) ? _ctx.imagePrefixURL + '/' : ''}${item}`,
            alt: 'image-'+ (index+1),
            class: "absolute block w-auto h-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 object-contain"
          }, null, 8, _hoisted_2)
        ]))
      }), 128))
    ]),
    _createElementVNode("button", {
      class: "absolute top-0 left-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none",
      "data-carousel-prev": "",
      type: "button"
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(carouselArrowStyles)
      }, _hoisted_5)
    ]),
    _createElementVNode("button", {
      class: "absolute top-0 right-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none",
      "data-carousel-next": "",
      type: "button"
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(carouselArrowStyles)
      }, _hoisted_8)
    ])
  ]))
}
}

})